import { DumbAttachment } from "../../../pending-news/DTOs/dumb-news-attachment";

export class ResourcePageDetails {
    pageId: number;
    pageName: string;
    pageContent: string;
    imageUrl: string;
    imageId: string;
    attachments: DumbAttachment[];
    lastUpdated: string;
}